import { render } from "./DeviceImagesRegistryComponent.vue?vue&type=template&id=7c24e3c2&scoped=true"
import script from "./DeviceImagesRegistryComponent.vue?vue&type=script&lang=js"
export * from "./DeviceImagesRegistryComponent.vue?vue&type=script&lang=js"

import "./DeviceImagesRegistryComponent.vue?vue&type=style&index=0&id=7c24e3c2&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c24e3c2"]])

export default __exports__